manageTagsCtrl.$inject = []

manageTagsCtrl.$inject = ['users', 'adminApi', 'op', '$uibModalInstance', 'allTags']

export default function manageTagsCtrl(users, adminApi, op, $modalInstance, allTags) {
  this.$onInit = function() {
    this.users = users
    this.showError = false
    this.errorMessage = ''
    this.loading = false
    this.resultResponse = null
    this.op = op
    this.selectedTag = null
    this.tagValues = users.reduce((prev, next) => {
      next.tags &&
        next.tags.forEach(tag => {
          if (prev.indexOf(tag) === -1) {
            prev.push(tag)
          }
        })
      return prev
    }, [])
    this.allTags = allTags
  }

  this.continueAction = function() {
    this.loading = true
    this.showError = false

    let userUuids = this.users.map(u => u.uuid)
    let actionData = {
      op: '',
      tag: this.selectedTag.trim()
    }
    if (op === 'Add Tags to Users') {
      actionData.op = 'add'
    } else if (op === 'Remove Tags from Users') {
      actionData.op = 'remove'
    } else {
      this.loading = false
      this.showError = true
      this.errorMessage = `Invalid op: ${op}`
    }
    adminApi.manageTags(userUuids, actionData).then(actionCallback, actionCallbackError)
  }

  var actionCallback = function(response) {
    this.loading = false
    this.resultResponse = response
    if (!response.errors || response.errors.length === 0) {
      $modalInstance.close(response)
    } else {
      this.showError = true
      this.errorMessage = 'Errors editing tags.'
      this.errors = response.errors
    }
  }.bind(this)

  var actionCallbackError = function(response) {
    this.loading = false
    this.showError = true
    this.errorMessage = response.message || response.errors || response
    this.errors = response.errors
  }.bind(this)
}
